import { render } from "./ApolicesView.vue?vue&type=template&id=aa6a1f1c"
import script from "./ApolicesView.vue?vue&type=script&lang=js"
export * from "./ApolicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__